import { RectangleHorizontal, RectangleVertical } from 'lucide-react';

export function AspectRatioIcon({ orientation }: { orientation: 'landscape' | 'portrait' }) {
  if (orientation === 'landscape') return <RectangleHorizontal className="h-3.5 w-3.5" />;
  return <RectangleVertical className="h-3.5 w-3.5" />;
}
